module.exports = __webpack_public_path__ + "static/media/NEW.c2ade166.svg";